module.exports = __webpack_public_path__ + "static/media/seat-sl.b21254ff.svg";